import { render, staticRenderFns } from "./RaisedLabel.vue?vue&type=template&id=29080bf0&scoped=true&"
import script from "./RaisedLabel.vue?vue&type=script&lang=js&"
export * from "./RaisedLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29080bf0",
  null
  
)

export default component.exports